let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g4gxV")).then(() => parcelRequire('epfvh'));